var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlyScalableImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 243,
    viewBox: "0 0 317 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_793)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.026 126.193C150.026 127.129 149.263 127.892 148.327 127.892C147.391 127.892 146.627 127.129 146.627 126.193C146.627 125.258 147.391 124.494 148.327 124.494C149.263 124.494 150.026 125.258 150.026 126.193Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M48.7964 62.3922C48.7964 63.7794 47.6669 64.9085 46.2791 64.9085C44.8914 64.9085 43.7618 63.7794 43.7618 62.3922C43.7618 61.005 44.8914 59.8759 46.2791 59.8759C47.6669 59.8759 48.7964 61.005 48.7964 62.3922Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.3233 62.3922C47.3233 62.9729 46.8607 63.4353 46.2798 63.4353C45.6989 63.4353 45.2363 62.9729 45.2363 62.3922C45.2363 61.8115 45.6989 61.3491 46.2798 61.3491C46.8607 61.3491 47.3233 61.8115 47.3233 62.3922Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.812 101.127C174.812 104.837 171.8 107.848 168.089 107.848C164.377 107.848 161.365 104.837 161.365 101.127C161.365 97.4166 164.377 94.4056 168.089 94.4056C171.8 94.4056 174.812 97.4166 174.812 101.127Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M168.078 103.922C169.623 103.922 170.875 102.671 170.875 101.127C170.875 99.5824 169.623 98.3306 168.078 98.3306C166.534 98.3306 165.281 99.5824 165.281 101.127C165.281 102.671 166.534 103.922 168.078 103.922Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.924 149.872L167.691 100.793L292.524 118.268L292.438 118.816L168.477 101.46L183.451 149.7L182.924 149.872Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8465 157.4H40.2656V168.745H40.8465V157.4Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8465 171.358H40.2656V174.595H40.8465V171.358Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8465 177.316H40.2656V180.552H40.8465V177.316Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 16.5928H118.119V27.9378H118.7V16.5928Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 30.5509H118.119V33.7877H118.7V30.5509Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 36.5084H118.119V39.7452H118.7V36.5084Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 42.4658H118.119V51.6601H118.7V42.4658Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.417 227.438H247.836V238.944H248.417V227.438Z",
    fill: "#172F78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M105.887 236.998C105.887 239.353 103.972 241.267 101.617 241.267C99.2606 241.267 97.3457 239.353 97.3457 236.998C97.3457 234.643 99.2606 232.729 101.617 232.729C103.972 232.729 105.887 234.643 105.887 236.998Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101.617 239.095C102.776 239.095 103.715 238.156 103.715 236.998C103.715 235.84 102.776 234.901 101.617 234.901C100.459 234.901 99.5195 235.84 99.5195 236.998C99.5195 238.156 100.459 239.095 101.617 239.095Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.701 190.413C260.155 190.413 262.144 188.425 262.144 185.972C262.144 183.519 260.155 181.531 257.701 181.531C255.247 181.531 253.258 183.519 253.258 185.972C253.258 188.425 255.247 190.413 257.701 190.413Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M257.701 188.155C258.907 188.155 259.885 187.178 259.885 185.972C259.885 184.767 258.907 183.789 257.701 183.789C256.495 183.789 255.518 184.767 255.518 185.972C255.518 187.178 256.495 188.155 257.701 188.155Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.949 91.1687C144.949 93.0721 143.411 94.6099 141.507 94.6099C139.603 94.6099 138.064 93.0721 138.064 91.1687C138.064 89.2654 139.603 87.7276 141.507 87.7276C143.411 87.7276 144.949 89.2654 144.949 91.1687Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M141.507 92.8571C142.44 92.8571 143.196 92.1012 143.196 91.1687C143.196 90.2363 142.44 89.4804 141.507 89.4804C140.575 89.4804 139.818 90.2363 139.818 91.1687C139.818 92.1012 140.575 92.8571 141.507 92.8571Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M270.943 231.858C271.971 231.858 272.804 231.025 272.804 229.997C272.804 228.97 271.971 228.137 270.943 228.137C269.915 228.137 269.082 228.97 269.082 229.997C269.082 231.025 269.915 231.858 270.943 231.858Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.798 127.354C257.798 127.935 257.335 128.398 256.754 128.398C256.174 128.398 255.711 127.935 255.711 127.354C255.711 126.774 256.174 126.311 256.754 126.311C257.335 126.311 257.798 126.774 257.798 127.354Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.72 211.189C115.72 211.759 115.257 212.232 114.676 212.232C114.095 212.232 113.633 211.77 113.633 211.189C113.633 210.609 114.095 210.146 114.676 210.146C115.257 210.146 115.72 210.609 115.72 211.189Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.148 179.423C177.039 179.423 174.92 178.961 173.317 178.036L134.073 155.389C132.449 154.453 131.545 153.174 131.545 151.808C131.545 150.442 132.438 149.173 134.073 148.227L173.113 125.537C176.329 123.677 181.568 123.677 184.785 125.537L224.029 148.184C225.653 149.12 226.557 150.399 226.557 151.765C226.557 153.131 225.664 154.4 224.029 155.346L184.989 178.036C183.376 178.961 181.267 179.434 179.148 179.434V179.423ZM178.943 124.86C176.964 124.86 174.985 125.29 173.468 126.161L134.428 148.851C133.029 149.657 132.266 150.701 132.266 151.797C132.266 152.894 133.029 153.937 134.428 154.744L173.672 177.391C176.695 179.133 181.601 179.133 184.613 177.391L223.652 154.701C225.051 153.894 225.815 152.851 225.815 151.754C225.815 150.657 225.051 149.614 223.652 148.808L184.408 126.161C182.902 125.29 180.923 124.86 178.933 124.86H178.943Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.375 139.388V120.58L202.59 123.752L184.786 113.472C181.666 111.665 176.599 111.665 173.48 113.472L170.704 115.235L132.105 120.386V139.538H132.116C132.159 140.678 132.923 141.818 134.44 142.7L173.684 165.347C176.804 167.153 181.871 167.153 184.99 165.347L224.03 142.657C225.536 141.786 226.3 140.646 226.354 139.506H226.375V139.399V139.388Z",
    fill: "url(#paint0_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 117.171L184.785 94.5239C181.666 92.7173 176.599 92.7173 173.479 94.5239L134.439 117.214C131.32 119.02 131.32 121.935 134.439 123.741L173.684 146.388C176.803 148.195 181.87 148.195 184.99 146.388L224.03 123.698C227.149 121.892 227.149 118.977 224.03 117.171Z",
    fill: "url(#paint1_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 122.558L184.99 145.248C181.871 147.055 176.804 147.055 173.684 145.248L134.44 122.601C133.127 121.849 132.374 120.892 132.17 119.913C131.88 121.279 132.633 122.698 134.44 123.741L173.684 146.388C176.804 148.195 181.871 148.195 184.99 146.388L224.03 123.698C225.848 122.655 226.601 121.225 226.3 119.87C226.085 120.859 225.332 121.806 224.03 122.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.271 151.41L188.41 152.486V150.335L190.271 149.27V151.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.154 149.163L192.293 150.238V148.098L194.154 147.023V149.163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.038 146.926L196.188 147.991V145.851L198.038 144.775V146.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.865 153.099L193.004 154.174V152.034L194.865 150.959V153.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.285 151.131L196.424 152.195V150.055L198.285 148.98V151.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.506 139.732L208.656 140.796V138.657L210.506 137.581V139.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22 133.549L219.359 134.624V132.473L221.22 131.409V133.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.933 144.678L200.072 145.754V143.603L201.933 142.539V144.678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M177.019 136.818L150.619 121.58C149.543 120.956 149.683 119.881 150.92 119.16L176.717 104.267C177.954 103.557 179.826 103.471 180.902 104.095L207.301 119.332C208.377 119.956 208.237 121.031 207 121.752L181.203 136.646C179.966 137.366 178.094 137.441 177.019 136.818Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.626 153.314L144.841 140.743C144.325 140.442 143.895 139.635 143.895 138.947V137.334C143.895 136.646 144.314 136.323 144.841 136.624L166.626 149.195C167.142 149.496 167.572 150.303 167.572 150.991V152.604C167.572 153.292 167.153 153.615 166.626 153.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.375 104.095V85.2865L202.59 88.4589L184.786 78.1784C181.666 76.3718 176.599 76.3718 173.48 78.1784L170.704 79.942L132.105 85.093V104.245H132.116C132.159 105.385 132.923 106.525 134.44 107.407L173.684 130.054C176.804 131.86 181.871 131.86 184.99 130.054L224.03 107.364C225.536 106.493 226.3 105.353 226.354 104.213H226.375V104.105V104.095Z",
    fill: "url(#paint2_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 81.8884L184.785 59.2414C181.666 57.4348 176.599 57.4348 173.479 59.2414L134.439 81.9314C131.32 83.738 131.32 86.6523 134.439 88.4589L173.684 111.106C176.803 112.912 181.87 112.912 184.99 111.106L224.03 88.4158C227.149 86.6092 227.149 83.695 224.03 81.8884Z",
    fill: "url(#paint3_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.333 83.2541L182.462 70.0595C180.644 69.0056 177.697 69.0056 175.879 70.0595L153.137 83.2756C151.319 84.3295 151.319 86.0285 153.137 87.0824L176.008 100.277C177.826 101.331 180.774 101.331 182.592 100.277L205.333 87.0609C207.151 86.007 207.151 84.308 205.333 83.2541Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 87.276L184.99 109.966C181.871 111.773 176.804 111.773 173.684 109.966L134.44 87.319C133.127 86.5662 132.374 85.6091 132.17 84.6306C131.88 85.9963 132.633 87.4158 134.44 88.4589L173.684 111.106C176.804 112.912 181.871 112.912 184.99 111.106L224.03 88.4158C225.848 87.3727 226.601 85.9425 226.3 84.5876C226.085 85.5769 225.332 86.5232 224.03 87.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.271 116.128L188.41 117.192V115.052L190.271 113.977V116.128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.154 113.88L192.293 114.956V112.805L194.154 111.74V113.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.038 111.644L196.188 112.708V110.568L198.038 109.493V111.644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.865 117.816L193.004 118.891V116.741L194.865 115.676V117.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.285 115.837L196.424 116.913V114.773L198.285 113.697V115.837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.506 104.439L208.656 105.514V103.374L210.506 102.299V104.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22 98.2661L219.359 99.3415V97.1907L221.22 96.1154V98.2661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.933 109.396L200.072 110.471V108.321L201.933 107.256V109.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.375 68.8121V50.0041L202.59 53.1764L184.786 42.896C181.666 41.0894 176.599 41.0894 173.48 42.896L170.704 44.6596L132.105 49.8105V68.9626H132.116C132.159 70.1025 132.923 71.2424 134.44 72.1242L173.684 94.7712C176.804 96.5778 181.871 96.5778 184.99 94.7712L224.03 72.0812C225.536 71.2101 226.3 70.0702 226.354 68.9304H226.375V68.8228V68.8121Z",
    fill: "url(#paint4_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 46.606L184.785 23.959C181.666 22.1524 176.599 22.1524 173.479 23.959L134.439 46.649C131.32 48.4556 131.32 51.3698 134.439 53.1764L173.684 75.8234C176.803 77.63 181.87 77.63 184.99 75.8234L224.03 53.1334C227.149 51.3268 227.149 48.4126 224.03 46.606Z",
    fill: "url(#paint5_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.03 51.9935L184.99 74.6835C181.871 76.4901 176.804 76.4901 173.684 74.6835L134.44 52.0365C133.127 51.2838 132.374 50.3267 132.17 49.3481C131.88 50.7138 132.633 52.1333 134.44 53.1764L173.684 75.8234C176.804 77.63 181.871 77.63 184.99 75.8234L224.03 53.1334C225.848 52.0903 226.601 50.6601 226.3 49.3051C226.085 50.2944 225.332 51.2408 224.03 51.9935Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.271 80.8346L188.41 81.9099V79.77L190.271 78.6946V80.8346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.154 78.5978L192.293 79.6732V77.5225L194.154 76.4471V78.5978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.038 76.3503L196.188 77.4257V75.2857L198.038 74.2104V76.3503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.865 82.5336L193.004 83.609V81.4583L194.865 80.3829V82.5336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.285 80.555L196.424 81.6303V79.4904L198.285 78.415V80.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.506 69.1562L208.656 70.2315V68.0916L210.506 67.0162V69.1562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22 62.9836L219.359 64.0482V61.9083L221.22 60.8329V62.9836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.933 74.1136L200.072 75.1782V73.0382L201.933 71.9629V74.1136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.729 219.577C107.61 219.577 105.501 219.115 103.887 218.19L64.6433 195.543C63.0189 194.607 62.1152 193.328 62.1152 191.962C62.1152 190.596 63.0081 189.317 64.6433 188.381L103.683 165.691C106.9 163.831 112.139 163.831 115.355 165.691L154.599 188.338C156.224 189.274 157.127 190.553 157.127 191.919C157.127 193.285 156.234 194.564 154.599 195.5L115.56 218.19C113.946 219.115 111.837 219.588 109.718 219.588L109.729 219.577ZM109.524 165.013C107.545 165.013 105.566 165.454 104.049 166.315L65.0091 189.005C63.6106 189.811 62.8468 190.854 62.8468 191.951C62.8468 193.048 63.6106 194.091 65.0091 194.898L104.253 217.545C107.276 219.287 112.182 219.287 115.194 217.545L154.233 194.855C155.632 194.048 156.396 193.005 156.396 191.908C156.396 190.811 155.632 189.768 154.233 188.962L114.989 166.315C113.483 165.444 111.504 165.013 109.514 165.013H109.524Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.955 179.531V160.723L133.17 163.895L115.366 153.615C112.246 151.808 107.179 151.808 104.06 153.615L101.284 155.378L62.6855 160.529V179.681H62.6963C62.7393 180.821 63.5031 181.961 65.02 182.843L104.264 205.49C107.384 207.297 112.451 207.297 115.57 205.49L154.61 182.8C156.116 181.929 156.88 180.789 156.934 179.649H156.955V179.542V179.531Z",
    fill: "url(#paint6_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 157.314L115.366 134.667C112.246 132.86 107.179 132.86 104.059 134.667L65.0195 157.357C61.8998 159.164 61.8998 162.078 65.0195 163.884L104.264 186.531C107.383 188.338 112.45 188.338 115.57 186.531L154.61 163.841C157.729 162.035 157.729 159.121 154.61 157.314Z",
    fill: "url(#paint7_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 162.701L115.57 185.391C112.451 187.198 107.384 187.198 104.264 185.391L65.0199 162.744C63.7075 161.992 62.9545 161.035 62.7501 160.056C62.4596 161.422 63.2126 162.841 65.0199 163.884L104.264 186.531C107.384 188.338 112.451 188.338 115.57 186.531L154.61 163.841C156.428 162.798 157.181 161.368 156.88 160.013C156.665 161.002 155.912 161.949 154.61 162.701Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.851 191.553L118.99 192.629V190.489L120.851 189.413V191.553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.735 189.317L122.885 190.381V188.241L124.735 187.166V189.317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.629 187.069L126.768 188.144V185.994L128.629 184.929V187.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.444 193.252L123.594 194.317V192.177L125.444 191.102V193.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.866 191.274L127.015 192.349V190.198L128.866 189.134V191.274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.097 179.875L139.236 180.95V178.8L141.097 177.735V179.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.801 173.692L149.939 174.767V172.627L151.801 171.552V173.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.513 184.822L130.652 185.897V183.757L132.513 182.682V184.822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M107.599 176.971L81.1994 161.734C80.1236 161.11 80.2635 160.035 81.5006 159.314L107.298 144.42C108.535 143.7 110.407 143.625 111.482 144.248L137.882 159.486C138.957 160.11 138.818 161.185 137.581 161.906L111.784 176.799C110.546 177.52 108.675 177.595 107.599 176.971Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2076 193.457L75.4232 180.886C74.9069 180.585 74.4766 179.778 74.4766 179.09V177.477C74.4766 176.789 74.8961 176.466 75.4232 176.767L97.2076 189.338C97.724 189.639 98.1543 190.446 98.1543 191.134V192.747C98.1543 193.435 97.7347 193.758 97.2076 193.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.955 144.248V125.44L133.17 128.613L115.366 118.332C112.246 116.526 107.179 116.526 104.06 118.332L101.284 120.096L62.6855 125.247V144.399H62.6963C62.7393 145.539 63.5031 146.679 65.02 147.56L104.264 170.207C107.384 172.014 112.451 172.014 115.57 170.207L154.61 147.517C156.116 146.646 156.88 145.507 156.934 144.367H156.955V144.259V144.248Z",
    fill: "url(#paint8_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 122.031L115.366 99.3845C112.246 97.5779 107.179 97.5779 104.059 99.3845L65.0195 122.074C61.8998 123.881 61.8998 126.795 65.0195 128.602L104.264 151.249C107.383 153.056 112.45 153.056 115.57 151.249L154.61 128.559C157.729 126.752 157.729 123.838 154.61 122.031Z",
    fill: "url(#paint9_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M135.923 123.408L113.052 110.213C111.234 109.159 108.287 109.159 106.469 110.213L83.7268 123.429C81.9088 124.483 81.9088 126.182 83.7268 127.236L106.598 140.431C108.416 141.485 111.363 141.485 113.192 140.431L135.934 127.215C137.752 126.161 137.752 124.462 135.934 123.408H135.923Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 127.419L115.57 150.109C112.451 151.916 107.384 151.916 104.264 150.109L65.0199 127.462C63.7075 126.709 62.9545 125.752 62.7501 124.774C62.4596 126.139 63.2126 127.559 65.0199 128.602L104.264 151.249C107.384 153.056 112.451 153.056 115.57 151.249L154.61 128.559C156.428 127.516 157.181 126.086 156.88 124.731C156.665 125.72 155.912 126.666 154.61 127.419Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.851 156.271L118.99 157.346V155.195L120.851 154.131V156.271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.735 154.023L122.885 155.099V152.959L124.735 151.883V154.023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.629 151.787L126.768 152.862V150.711L128.629 149.636V151.787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.444 157.959L123.594 159.035V156.895L125.444 155.819V157.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.866 155.991L127.015 157.056V154.916L128.866 153.841V155.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.097 144.592L139.236 145.657V143.517L141.097 142.442V144.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.801 138.409L149.939 139.485V137.334L151.801 136.269V138.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.513 149.539L130.652 150.614V148.475L132.513 147.399V149.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.955 108.966V90.1579L133.17 93.3302L115.366 83.0498C112.246 81.2432 107.179 81.2432 104.06 83.0498L101.284 84.8134L62.6855 89.9643V109.116H62.6963C62.7393 110.256 63.5031 111.396 65.02 112.278L104.264 134.925C107.384 136.732 112.451 136.732 115.57 134.925L154.61 112.235C156.116 111.364 156.88 110.224 156.934 109.084H156.955V108.977V108.966Z",
    fill: "url(#paint10_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 86.749L115.366 64.102C112.246 62.2954 107.179 62.2954 104.059 64.102L65.0195 86.792C61.8998 88.5986 61.8998 91.5129 65.0195 93.3195L104.264 115.966C107.383 117.773 112.45 117.773 115.57 115.966L154.61 93.2764C157.729 91.4698 157.729 88.5556 154.61 86.749Z",
    fill: "url(#paint11_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 86.749L115.366 64.102C112.246 62.2954 107.179 62.2954 104.059 64.102L65.0195 86.792C61.8998 88.5986 61.8998 91.5129 65.0195 93.3195L104.264 115.966C107.383 117.773 112.45 117.773 115.57 115.966L154.61 93.2764C157.729 91.4698 157.729 88.5556 154.61 86.749Z",
    fill: "url(#paint12_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.891 108.633C108.449 108.633 107.008 108.31 105.889 107.665L79.8874 92.6527C78.7255 91.986 78.0801 91.0612 78.0801 90.0504C78.0801 89.0395 78.7255 88.1147 79.8874 87.448L105.749 72.4145C107.997 71.1133 111.515 71.1241 113.753 72.4145L139.754 87.4265C140.916 88.0932 141.561 89.018 141.561 90.0289C141.561 91.0397 140.916 91.9645 139.754 92.6312L113.892 107.665C112.774 108.31 111.332 108.633 109.891 108.633ZM109.751 72.4683C108.481 72.4683 107.223 72.7479 106.254 73.2963L80.393 88.3298C79.5539 88.8137 79.0913 89.4267 79.0913 90.0504C79.0913 90.6741 79.5539 91.287 80.393 91.7709L106.394 106.772C108.32 107.88 111.45 107.88 113.376 106.772L139.238 91.7387C140.077 91.2548 140.539 90.6418 140.539 90.0181C140.539 89.3944 140.077 88.7815 139.238 88.2975L113.236 73.2856C112.268 72.7264 111.009 72.4575 109.74 72.4575L109.751 72.4683Z",
    fill: "#ED58B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 92.1366L115.57 114.827C112.451 116.633 107.384 116.633 104.264 114.827L65.0199 92.1796C63.7075 91.4268 62.9545 90.4698 62.7501 89.4912C62.4596 90.8569 63.2126 92.2764 65.0199 93.3195L104.264 115.966C107.384 117.773 112.451 117.773 115.57 115.966L154.61 93.2764C156.428 92.2333 157.181 90.8031 156.88 89.4482C156.665 90.4375 155.912 91.3838 154.61 92.1366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.851 120.988L118.99 122.053V119.913L120.851 118.838V120.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.735 118.741L122.885 119.816V117.666L124.735 116.601V118.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.629 116.504L126.768 117.569V115.429L128.629 114.353V116.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.444 122.677L123.594 123.752V121.601L125.444 120.537V122.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.866 120.698L127.015 121.773V119.633L128.866 118.558V120.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.097 109.299L139.236 110.375V108.235L141.097 107.159V109.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.801 103.127L149.939 104.202V102.051L151.801 100.976V103.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.513 114.257L130.652 115.332V113.181L132.513 112.117V114.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.31 219.534C246.201 219.534 244.082 219.072 242.479 218.147L203.235 195.5C201.611 194.564 200.707 193.285 200.707 191.919C200.707 190.553 201.6 189.274 203.235 188.338L242.275 165.648C245.491 163.788 250.73 163.788 253.947 165.648L293.191 188.295C294.815 189.231 295.719 190.51 295.719 191.876C295.719 193.242 294.826 194.511 293.191 195.457L254.151 218.147C252.538 219.072 250.429 219.545 248.31 219.545V219.534ZM248.105 164.97C246.126 164.97 244.147 165.411 242.63 166.272L203.59 188.962C202.192 189.768 201.428 190.811 201.428 191.908C201.428 193.005 202.192 194.048 203.59 194.855L242.834 217.502C245.857 219.244 250.763 219.244 253.775 217.502L292.814 194.812C294.213 194.005 294.977 192.962 294.977 191.865C294.977 190.768 294.213 189.725 292.814 188.919L253.57 166.272C252.064 165.401 250.085 164.97 248.095 164.97H248.105Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.537 179.488V160.68L271.752 163.852L253.948 153.572C250.828 151.765 245.761 151.765 242.642 153.572L239.866 155.335L201.268 160.486V179.638H201.278C201.321 180.778 202.085 181.918 203.602 182.8L242.846 205.447C245.966 207.254 251.033 207.254 254.152 205.447L293.192 182.757C294.698 181.886 295.462 180.746 295.516 179.606H295.537V179.499V179.488Z",
    fill: "url(#paint13_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 157.282L253.948 134.635C250.828 132.828 245.761 132.828 242.641 134.635L203.602 157.325C200.482 159.131 200.482 162.045 203.602 163.852L242.846 186.499C245.965 188.306 251.032 188.306 254.152 186.499L293.192 163.809C296.311 162.002 296.311 159.088 293.192 157.282Z",
    fill: "url(#paint14_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 162.669L254.152 185.359C251.033 187.166 245.966 187.166 242.846 185.359L203.602 162.712C202.29 161.959 201.536 161.002 201.332 160.024C201.042 161.39 201.795 162.809 203.602 163.852L242.846 186.499C245.966 188.306 251.033 188.306 254.152 186.499L293.192 163.809C295.01 162.766 295.763 161.336 295.462 159.981C295.247 160.97 294.494 161.916 293.192 162.669Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.433 191.521L257.572 192.586V190.446L259.433 189.37V191.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.317 189.274L261.467 190.349V188.198L263.317 187.134V189.274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.211 187.026L265.35 188.101V185.961L267.211 184.886V187.026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.026 193.209L262.176 194.285V192.134L264.026 191.069V193.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.448 191.231L265.598 192.306V190.166L267.448 189.091V191.231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.679 179.832L277.818 180.907V178.767L279.679 177.692V179.832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.383 173.659L288.521 174.724V172.584L290.383 171.509V173.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.095 184.789L269.234 185.854V183.714L271.095 182.639V184.789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M246.181 176.928L219.781 161.691C218.705 161.067 218.845 159.992 220.082 159.271L245.879 144.377C247.117 143.657 248.988 143.582 250.064 144.205L276.464 159.443C277.539 160.067 277.399 161.142 276.162 161.863L250.365 176.756C249.128 177.477 247.256 177.552 246.181 176.928Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.788 193.424L214.004 180.853C213.487 180.552 213.057 179.746 213.057 179.058V177.445C213.057 176.756 213.476 176.434 214.004 176.735L235.788 189.306C236.304 189.607 236.735 190.413 236.735 191.102V192.715C236.735 193.403 236.315 193.726 235.788 193.424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.537 144.205V125.397L271.752 128.57L253.948 118.289C250.828 116.483 245.761 116.483 242.642 118.289L239.866 120.053L201.268 125.204V144.356H201.278C201.321 145.496 202.085 146.636 203.602 147.517L242.846 170.164C245.966 171.971 251.033 171.971 254.152 170.164L293.192 147.474C294.698 146.603 295.462 145.464 295.516 144.324H295.537V144.216V144.205Z",
    fill: "url(#paint15_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 121.999L253.948 99.3522C250.828 97.5456 245.761 97.5456 242.641 99.3522L203.602 122.042C200.482 123.849 200.482 126.763 203.602 128.57L242.846 151.217C245.965 153.023 251.032 153.023 254.152 151.217L293.192 128.527C296.311 126.72 296.311 123.806 293.192 121.999Z",
    fill: "url(#paint16_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M274.505 123.365L251.634 110.17C249.816 109.116 246.869 109.116 245.051 110.17L222.309 123.386C220.491 124.44 220.491 126.139 222.309 127.193L245.18 140.388C246.998 141.442 249.945 141.442 251.763 140.388L274.505 127.172C276.323 126.118 276.323 124.419 274.505 123.365Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 127.376L254.152 150.066C251.033 151.873 245.966 151.873 242.846 150.066L203.602 127.419C202.29 126.666 201.536 125.709 201.332 124.731C201.042 126.096 201.795 127.516 203.602 128.559L242.846 151.206C245.966 153.013 251.033 153.013 254.152 151.206L293.192 128.516C295.01 127.473 295.763 126.043 295.462 124.688C295.247 125.677 294.494 126.623 293.192 127.376Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.433 156.228L257.572 157.303V155.163L259.433 154.088V156.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.317 153.991L261.467 155.056V152.916L263.317 151.84V153.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.211 151.744L265.35 152.819V150.668L267.211 149.604V151.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.026 157.927L262.176 158.991V156.852L264.026 155.776V157.927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.448 155.948L265.598 157.024V154.873L267.448 153.808V155.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.679 144.549L277.818 145.625V143.474L279.679 142.409V144.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.383 138.366L288.521 139.441V137.302L290.383 136.226V138.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.095 149.507L269.234 150.571V148.431L271.095 147.356V149.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.537 108.923V90.1149L271.752 93.2872L253.948 83.0068C250.828 81.2002 245.761 81.2002 242.642 83.0068L239.866 84.7704L201.268 89.9213V109.073H201.278C201.321 110.213 202.085 111.353 203.602 112.235L242.846 134.882C245.966 136.689 251.033 136.689 254.152 134.882L293.192 112.192C294.698 111.321 295.462 110.181 295.516 109.041H295.537V108.934V108.923Z",
    fill: "url(#paint17_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 86.706L253.948 64.059C250.828 62.2524 245.761 62.2524 242.641 64.059L203.602 86.749C200.482 88.5556 200.482 91.4698 203.602 93.2764L242.846 115.923C245.965 117.73 251.032 117.73 254.152 115.923L293.192 93.2334C296.311 91.4268 296.311 88.5126 293.192 86.706Z",
    fill: "url(#paint18_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.192 92.0936L254.152 114.784C251.033 116.59 245.966 116.59 242.846 114.784L203.602 92.1366C202.29 91.3838 201.536 90.4268 201.332 89.4482C201.042 90.8139 201.795 92.2333 203.602 93.2764L242.846 115.923C245.966 117.73 251.033 117.73 254.152 115.923L293.192 93.2334C295.01 92.1903 295.763 90.7601 295.462 89.4052C295.247 90.3945 294.494 91.3408 293.192 92.0936Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.433 120.945L257.572 122.021V119.87L259.433 118.805V120.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.317 118.698L261.467 119.773V117.633L263.317 116.558V118.698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.211 116.461L265.35 117.536V115.386L267.211 114.31V116.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.026 122.634L262.176 123.709V121.569L264.026 120.494V122.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.448 120.666L265.598 121.741V119.59L267.448 118.515V120.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.679 109.267L277.818 110.342V108.192L279.679 107.116V109.267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.383 103.084L288.521 104.159V102.008L290.383 100.944V103.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.095 114.214L269.234 115.289V113.149L271.095 112.074V114.214Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89 259.677C176.782 259.677 174.662 259.215 173.059 258.29L133.815 235.643C132.191 234.707 131.287 233.428 131.287 232.062C131.287 230.696 132.18 229.417 133.815 228.481L172.855 205.791C176.072 203.931 181.311 203.931 184.527 205.791L223.771 228.438C225.396 229.374 226.299 230.653 226.299 232.019C226.299 233.385 225.406 234.664 223.771 235.6L184.732 258.29C183.118 259.215 181.009 259.688 178.89 259.688V259.677ZM178.686 205.114C176.706 205.114 174.727 205.554 173.21 206.415L134.17 229.105C132.772 229.911 132.008 230.954 132.008 232.051C132.008 233.148 132.772 234.191 134.17 234.998L173.414 257.645C176.437 259.387 181.343 259.387 184.355 257.645L223.395 234.955C224.793 234.148 225.557 233.105 225.557 232.008C225.557 230.911 224.793 229.868 223.395 229.062L184.151 206.415C182.645 205.544 180.665 205.114 178.675 205.114H178.686Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.874 229.47L183.139 211.727C180.697 210.318 176.728 210.318 174.286 211.727L143.712 229.503C141.27 230.911 141.27 233.202 143.712 234.611L174.447 252.354C176.889 253.763 180.859 253.763 183.301 252.354L213.874 234.578C216.316 233.17 216.316 230.879 213.874 229.47Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.116 219.642V200.834L202.33 204.006L184.526 193.726C181.407 191.919 176.34 191.919 173.22 193.726L170.445 195.489L131.846 200.64V219.792H131.857C131.9 220.932 132.663 222.072 134.18 222.954L173.424 245.601C176.544 247.407 181.611 247.407 184.731 245.601L223.77 222.911C225.277 222.04 226.04 220.9 226.094 219.76H226.116V219.652V219.642Z",
    fill: "url(#paint19_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 197.425L184.538 174.778C181.418 172.971 176.351 172.971 173.231 174.778L134.192 197.468C131.072 199.274 131.072 202.189 134.192 203.995L173.436 226.642C176.555 228.449 181.622 228.449 184.742 226.642L223.782 203.952C226.901 202.146 226.901 199.231 223.782 197.425Z",
    fill: "url(#paint20_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 202.812L184.742 225.502C181.623 227.309 176.556 227.309 173.436 225.502L134.192 202.855C132.88 202.103 132.127 201.145 131.922 200.167C131.632 201.533 132.385 202.952 134.192 203.995L173.436 226.642C176.556 228.449 181.623 228.449 184.742 226.642L223.782 203.952C225.6 202.909 226.353 201.479 226.052 200.124C225.837 201.113 225.084 202.06 223.782 202.812Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.013 231.664L188.162 232.739V230.589L190.013 229.513V231.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.906 229.417L192.045 230.492V228.352L193.906 227.277V229.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.791 227.18L195.93 228.244V226.105L197.791 225.029V227.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.617 233.352L192.756 234.428V232.288L194.617 231.212V233.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.037 231.385L196.176 232.449V230.309L198.037 229.234V231.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.258 219.986L208.397 221.05V218.91L210.258 217.835V219.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.962 213.802L219.112 214.878V212.727L220.962 211.662V213.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.675 224.932L199.825 226.008V223.857L201.675 222.792V224.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M176.761 217.072L150.362 201.834C149.286 201.21 149.426 200.135 150.663 199.414L176.46 184.52C177.697 183.811 179.569 183.725 180.644 184.348L207.044 199.586C208.12 200.21 207.98 201.285 206.743 202.006L180.946 216.899C179.709 217.62 177.837 217.695 176.761 217.072Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.38 233.567L144.595 220.997C144.079 220.695 143.649 219.889 143.649 219.201V217.588C143.649 216.899 144.068 216.577 144.595 216.878L166.38 229.449C166.896 229.75 167.326 230.556 167.326 231.245V232.858C167.326 233.546 166.907 233.869 166.38 233.567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.116 184.348V165.54L202.33 168.713L184.526 158.432C181.407 156.626 176.34 156.626 173.22 158.432L170.445 160.196L131.846 165.347V184.499H131.857C131.9 185.639 132.663 186.779 134.18 187.661L173.424 210.308C176.544 212.114 181.611 212.114 184.731 210.308L223.77 187.618C225.277 186.746 226.04 185.607 226.094 184.467H226.116V184.359V184.348Z",
    fill: "url(#paint21_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 162.142L184.538 139.495C181.418 137.689 176.351 137.689 173.231 139.495L134.192 162.185C131.072 163.992 131.072 166.906 134.192 168.713L173.436 191.36C176.555 193.166 181.622 193.166 184.742 191.36L223.782 168.67C226.901 166.863 226.901 163.949 223.782 162.142Z",
    fill: "url(#paint22_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.084 163.508L182.213 150.313C180.395 149.26 177.447 149.26 175.629 150.313L152.887 163.53C151.069 164.583 151.069 166.282 152.887 167.336L175.758 180.531C177.576 181.585 180.524 181.585 182.342 180.531L205.084 167.315C206.902 166.261 206.902 164.562 205.084 163.508Z",
    fill: "#06033E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 167.53L184.742 190.22C181.623 192.026 176.556 192.026 173.436 190.22L134.192 167.573C132.88 166.82 132.127 165.863 131.922 164.884C131.632 166.25 132.385 167.67 134.192 168.713L173.436 191.36C176.556 193.166 181.623 193.166 184.742 191.36L223.782 168.67C225.6 167.627 226.353 166.196 226.052 164.841C225.837 165.831 225.084 166.777 223.782 167.53Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.013 196.382L188.162 197.446V195.306L190.013 194.231V196.382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.906 194.134L192.045 195.21V193.059L193.906 191.994V194.134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.791 191.887L195.93 192.962V190.822L197.791 189.747V191.887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.617 198.07L192.756 199.145V196.995L194.617 195.93V198.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.037 196.091L196.176 197.167V195.027L198.037 193.951V196.091Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.258 184.693L208.397 185.768V183.628L210.258 182.553V184.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.962 178.52L219.112 179.585V177.445L220.962 176.369V178.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.675 189.65L199.825 190.725V188.575L201.675 187.499V189.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.116 149.066V130.258L202.33 133.43L184.526 123.15C181.407 121.343 176.34 121.343 173.22 123.15L170.445 124.913L131.846 130.064V149.216H131.857C131.9 150.356 132.663 151.496 134.18 152.378L173.424 175.025C176.544 176.832 181.611 176.832 184.731 175.025L223.77 152.335C225.277 151.464 226.04 150.324 226.094 149.184H226.116V149.077V149.066Z",
    fill: "url(#paint23_linear_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 126.86L184.538 104.213C181.418 102.406 176.351 102.406 173.231 104.213L134.192 126.903C131.072 128.709 131.072 131.624 134.192 133.43L173.436 156.077C176.555 157.884 181.622 157.884 184.742 156.077L223.782 133.387C226.901 131.581 226.901 128.666 223.782 126.86Z",
    fill: "url(#paint24_radial_1_793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.782 132.237L184.742 154.927C181.623 156.733 176.556 156.733 173.436 154.927L134.192 132.28C132.88 131.527 132.127 130.57 131.922 129.591C131.632 130.957 132.385 132.376 134.192 133.42L173.436 156.067C176.556 157.873 181.623 157.873 184.742 156.067L223.782 133.377C225.6 132.333 226.353 130.903 226.052 129.548C225.837 130.538 225.084 131.484 223.782 132.237Z",
    fill: "#020F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.013 161.088L188.162 162.164V160.024L190.013 158.948V161.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.906 158.852L192.045 159.916V157.776L193.906 156.701V158.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.791 156.604L195.93 157.68V155.529L197.791 154.464V156.604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.617 162.788L192.756 163.852V161.712L194.617 160.637V162.788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.037 160.809L196.176 161.884V159.733L198.037 158.669V160.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.258 149.41L208.397 150.485V148.335L210.258 147.27V149.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.962 143.227L219.112 144.302V142.162L220.962 141.087V143.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.675 154.367L199.825 155.432V153.292L201.675 152.217V154.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.792 206.836L272.426 207.469L339.979 246.456L340.345 245.823L272.792 206.836Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.633 229.922L347.053 217.469C345.084 216.33 342.47 215.588 339.705 215.372L316.544 213.555C313.672 213.329 310.95 212.555 308.885 211.361L287.305 198.909L287.67 198.274L309.25 210.727C311.219 211.867 313.822 212.609 316.598 212.824L339.759 214.641C342.632 214.867 345.353 215.652 347.419 216.835L368.999 229.288L368.633 229.922Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.305 263L289.725 250.547C287.627 249.332 286.24 247.708 285.831 245.988L282.679 232.621C282.313 231.094 281.054 229.632 279.129 228.524L257.549 216.071L257.915 215.437L279.495 227.89C281.603 229.105 282.98 230.729 283.389 232.449L286.541 245.816C286.907 247.343 288.165 248.805 290.091 249.913L311.671 262.366L311.305 263Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.645 254.731L302.645 241.45C301.473 240.772 300.537 239.987 299.848 239.106L290.586 227.191C289.962 226.384 289.09 225.664 288.004 225.029L265.004 211.749L265.37 211.114L288.37 224.395C289.542 225.072 290.478 225.857 291.167 226.739L300.429 238.654C301.053 239.46 301.924 240.181 303.011 240.815L326.011 254.096L325.645 254.731Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.303 238.192L331.292 224.911C330.195 224.276 328.915 223.771 327.484 223.395L306.85 218.05C305.366 217.663 304.021 217.125 302.859 216.459L279.859 203.178L280.225 202.543L303.236 215.824C304.333 216.459 305.624 216.975 307.044 217.34L327.677 222.685C329.173 223.072 330.507 223.61 331.668 224.276L354.679 237.557L354.313 238.192H354.303Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7775 197.954L-0.0214844 238.172L0.343839 238.806L70.1428 198.588L69.7775 197.954Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7618 203.708L9.96289 243.926L10.3282 244.56L80.1272 204.342L79.7618 203.708Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7327 209.466L19.9338 249.684L20.2991 250.318L90.0981 210.1L89.7327 209.466Z",
    fill: "#03A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7169 215.22L29.918 255.438L30.2833 256.072L100.082 215.854L99.7169 215.22Z",
    fill: "#03A7D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_793",
    x1: 126.436,
    y1: 139.409,
    x2: 192.908,
    y2: 139.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.645 89.5772) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_793",
    x1: 0.000877618,
    y1: 104.116,
    x2: 1.07665,
    y2: 104.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.538276 54.2948) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_793",
    x1: 0.000877618,
    y1: 68.8336,
    x2: 1.07665,
    y2: 68.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.538276 19.0016) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_793",
    x1: 57.0162,
    y1: 179.552,
    x2: 123.499,
    y2: 179.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2253 129.72) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_793",
    x1: 57.0162,
    y1: 144.27,
    x2: 123.499,
    y2: 144.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2253 94.4378) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_793",
    x1: 57.0162,
    y1: 108.977,
    x2: 123.499,
    y2: 108.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2253 59.1554) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3282 68.0916) scale(102.069 102.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_793",
    x1: 195.598,
    y1: 179.509,
    x2: 262.07,
    y2: 179.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.807 129.677) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_793",
    x1: 195.598,
    y1: 144.227,
    x2: 262.07,
    y2: 144.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.807 94.3948) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_793",
    x1: 195.598,
    y1: 108.944,
    x2: 262.07,
    y2: 108.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.807 59.1124) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_793",
    x1: 126.177,
    y1: 219.663,
    x2: 192.659,
    y2: 219.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.397 169.831) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_793",
    x1: 126.177,
    y1: 184.37,
    x2: 192.659,
    y2: 184.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.397 134.549) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_793",
    x1: 126.177,
    y1: 149.087,
    x2: 192.659,
    y2: 149.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E6BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#143F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1_793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.397 99.2554) scale(148.456 148.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#03BAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0895C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 263,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlyScalableImg);
export default __webpack_public_path__ + "static/media/HighlyScalableImg.9d1ef47ecaf0880dc9014f5e6674907e.svg";
export { ForwardRef as ReactComponent };